// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","MenuItem":"bfy_a bhc_un bhc_cw bhc_a","MenuItem__Btn":"bfy_b bhc_z"};